import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { get } from 'lodash'

import { apolloService } from '../../common/services'

import { UPDATE_DICTIONARY_WORD_MUTATION } from '../graphql/mutations'
import { transformToUpdateDictionaryWordArgs } from '../graphql/transformers'
import { UPDATE_DICTIONARY_WORD } from '../redux/action-types'

const useUpdateDictionaryWordMutation = (type, refetchLastEvent) => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(store =>
    get(store.dictionaryWords.data, type.fieldName, {}),
  )

  const mutate = useCallback(
    async (id, data) => {
      await apolloService.mutate(
        UPDATE_DICTIONARY_WORD_MUTATION,
        {
          id,
          type: type.value,
          data: transformToUpdateDictionaryWordArgs(data),
        },
        dispatch,
        UPDATE_DICTIONARY_WORD,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent, type.value],
  )

  return [mutate, { isLoading, error }]
}

export default useUpdateDictionaryWordMutation
